import getAllRecipients from "./getAllRecipients";
import deleteNotificationRecipients from "./deleteNotificationRecipients"
const NotificationsRecipients = {
    getAllRecipients,
    deleteNotificationRecipients,
};

export default NotificationsRecipients;